An array of locations relevant to the provided geoLocation ordered by distance.

A maximum of 10 locations can be recommended.

This query accepts browser tokens that include the `query:ontologies` or `query:enhanced-job-posting` scope.
